import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ModalData } from "../modal/modal.service";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-tax-schedules
                        [tax]="{ itemId: data.id }"
                        [mode]="data.mode"
                        (saved)="onSaved()"
                        (cancelled)="onCancelled()"
                    ></s25-ng-tax-schedules>
                </div>
            </div>
        }
    `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditTaxScheduleComponent implements OnInit {
    @Input() data: {
        id?: number;
        mode: "create" | "copy" | "edit";
        onSave?: Function;
        onCancel?: VoidFunction;
    } & ModalData;

    isInit = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.onSave?.();
        this.data.closeModal();
    }

    onCancelled() {
        this.data.closeModal();
    }
}
